import appActionTypes from '../constants/types'

export const initialState = {
  data: [],
  isLoading: false,
  message: null,
  errorMessage: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case appActionTypes.cy_customer_offering_mapping.get.requested:
    case appActionTypes.cy_customer_offering_mapping.create.requested:
    case appActionTypes.cy_customer_offering_mapping.delete.requested:
    case appActionTypes.cy_customer_offering_mapping.edit.requested:
      return {
        ...state,
        isLoading: true,
        message: action.message,
        errorMessage: null,
      }
    case appActionTypes.cy_customer_offering_mapping.get.success:
      return {
        ...state,
        data: action.data,
        isLoading: false,
        message: action.message,
        errorMessage: null,
      }

    case appActionTypes.cy_customer_offering_mapping.create.success:
      var _newlist = JSON.parse(JSON.stringify(state.data))
      _newlist.push(action.data)
      return {
        ...state,
        data: _newlist,
        isLoading: false,
        message: action.message,
        errorMessage: null,
      }
    // return state

    case appActionTypes.cy_customer_offering_mapping.delete.success:
      var _newlist = JSON.parse(JSON.stringify(state.data))
      var index = _newlist.findIndex((obj) => obj._id === action.data?._id)
      if (index !== -1) _newlist.splice(index, 1)

      return {
        ...state,
        data: _newlist,
        isLoading: false,
        message: action.message,
        errorMessage: null,
      }

    case appActionTypes.cy_customer_offering_mapping.edit.success:
      var _newlist = JSON.parse(JSON.stringify(state.data))
      var index = _newlist.findIndex((obj) => obj._id === action.data?._id)
      if (index !== -1) _newlist[index] = action.data

      return {
        ...state,
        data: _newlist,
        isLoading: false,
        message: action.message,
        errorMessage: null,
      }
    // return state
    case appActionTypes.cy_customer_offering_mapping.get.fail:
    case appActionTypes.cy_customer_offering_mapping.create.fail:
    case appActionTypes.cy_customer_offering_mapping.delete.fail:
    case appActionTypes.cy_customer_offering_mapping.edit.fail:
      return {
        ...state,
        isLoading: false,
        message: null,
        errorMessage: action.errorMessage,
      }
    default:
      return state
  }
}
